import {AfterViewInit, ElementRef, Directive} from '@angular/core';
import { environment } from '../../environments/environment';

@Directive({
  selector: '[appCookieDlg]'
})
export class CookiedlgDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewInit() {
     var scriptElement = document.createElement("script");
     scriptElement.type = "text/javascript";
     scriptElement.src = environment.consentMgrUrl;
     this.elementRef.nativeElement.parentElement.appendChild(scriptElement);
  }
}
